import React, { useCallback, useState } from "react";
import Spinner from "../../common/Spinner";
import { auctionV2ApiClient } from "../../auctions-list-page/AuctionApiClient";
import styles from "./auctionLots.module.scss";
import events from "../../events";
export default function BidWatched({ itemId, isWatched: isInitiallyWatched, saveItemPositionState, onAdd, onRemove, }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isWatched, setIsWatched] = useState(isInitiallyWatched);
    const addToWatchedItems = useCallback(async () => {
        var _a;
        setIsLoading(true);
        try {
            await auctionV2ApiClient.addWatchedItem({
                itemId,
            });
            await (onAdd === null || onAdd === void 0 ? void 0 : onAdd(itemId));
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'Observation', {
                'item_id': itemId
            });
            setIsWatched(true);
        }
        catch (error) {
            if ((error === null || error === void 0 ? void 0 : error.status) === 403) {
                saveItemPositionState(itemId);
                events.openLogin.trigger({ open: true, centeredFixed: true });
            }
            else {
                console.error(error);
            }
        }
        finally {
            setIsLoading(false);
        }
    }, [itemId, onAdd]);
    const removeFromWatchedItems = useCallback(async () => {
        setIsLoading(true);
        try {
            await auctionV2ApiClient.removeWatchedItem(itemId);
            await (onRemove === null || onRemove === void 0 ? void 0 : onRemove(itemId));
            setIsWatched(false);
        }
        finally {
            setIsLoading(false);
        }
    }, [itemId, onRemove]);
    return (React.createElement("div", { className: styles.addToWatchlist }, isLoading ? (React.createElement(Spinner, { size: "mini" })) : (React.createElement("button", { "aria-label": isWatched ? "Unwatch item" : "Watch item", onClick: isWatched ? removeFromWatchedItems : addToWatchedItems }, isWatched ? React.createElement(HeartActiveIcon, null) : React.createElement(HeartInactiveIcon, null)))));
}
const HeartInactiveIcon = () => (React.createElement("svg", { width: "23", height: "19", viewBox: "0 0 23 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M14.3291 0.721334C12.6607 0.712418 11.0747 1.44514 9.99998 2.72131C8.93203 1.43642 7.34156 0.701612 5.67085 0.721334C2.53892 0.721334 0 3.26025 0 6.39219C0 11.7593 9.36708 16.9998 9.74684 17.2023C9.90006 17.3047 10.0999 17.3047 10.2532 17.2023C10.6329 16.9998 20 11.8352 20 6.39219C20 3.26025 17.461 0.721334 14.3291 0.721334ZM9.99998 16.1897C8.53162 15.3289 1.01266 10.7467 1.01266 6.39219C1.01266 3.81955 3.09821 1.73395 5.6709 1.73395C7.24634 1.71325 8.7207 2.50791 9.56963 3.8352C9.74199 4.07288 10.0745 4.12584 10.3121 3.95343C10.3575 3.92048 10.3975 3.8806 10.4304 3.8352C11.8383 1.682 14.7252 1.07783 16.8784 2.48576C18.1965 3.34767 18.9899 4.81723 18.9873 6.39214C18.9873 10.7972 11.4683 15.3542 9.99998 16.1897Z", fill: "black" })));
const HeartActiveIcon = () => (React.createElement("svg", { width: "23", height: "19", viewBox: "0 0 23 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M14.56 0.813397C17.5583 0.827995 19.9854 3.25502 20 6.25341C20 11.7467 10 17.1867 10 17.1867C10 17.1867 0 11.6667 0 6.25341C0 3.249 2.43555 0.813397 5.44002 0.813397C7.27915 0.799054 8.99854 1.72408 10 3.26671C11.0084 1.73158 12.7233 0.808956 14.56 0.813397Z", fill: "#f54b41" })));
